export default function CategoryTable({ items = [], renderItem }) {
  if (!items.length) return <p className="admin-empty-state">No categories or wellness concerns have been added.</p>;
  return <div className="admin-products">{items.map((item) => <div key={item._id}>{renderItem(item)}</div>)}</div>;
}
